/**
 * Stripe Provider Wrapper
 *
 * PURPOSE:
 * Loads Stripe.js and provides Stripe context to child components.
 * Must wrap any component that uses Stripe Elements (CardElement, etc.).
 *
 * USAGE:
 * Wrap SubscriptionPaymentModal with this provider to enable Stripe payments.
 *
 * FOR BEGINNERS:
 * This component initializes Stripe with our publishable key and makes
 * Stripe functionality available to any nested components.
 */

import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// Load Stripe with publishable key
// Note: Using hardcoded key for now - could be moved to env var
const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ||
    "pk_live_51S2KpyPlEkwtI7Trb9gN609KPjtMNMuFsiTzGf7MTP4YGAexk2fEOQMwMKJzKC6rDXNE96seYYxeboBJxAY9m9lT00IPDQ8lg7",
);

interface StripeProviderProps {
  children: React.ReactNode;
}

export const StripeProvider: React.FC<StripeProviderProps> = ({ children }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};
